import { useMemo } from 'react';
import { usePermission } from './usePermission'; // Adjust as needed

import { useSelector } from 'react-redux';

export const useVisibleLinks = (links, permissions2) => {
  const permissions = useSelector((state) => state.auth.permissions);
  const hasPermission = (perm) => !perm || permissions.includes(perm);

  return useMemo(() => {
    return links
      .map((item) => {
        const visibleSub =
          item.submenu?.filter((s) => hasPermission(s.permission)) || [];
        const keepParent =
          hasPermission(item.permission) || visibleSub.length > 0;
        return keepParent ? { ...item, submenu: visibleSub } : null;
      })
      .filter(Boolean);
  }, [links, permissions]);
};
